// @flow

import React from 'react';
import Referrer from './referrer';

type ACFProps = {
  field_key: string,
  form: string,
};

export default ({
  field_key,
  form,
}: ACFProps) => (
  <Referrer
    formName={form}
    name={field_key}
  />
);
